<template>
	<div class="container" :class="expanded ? '' : 'not-expanded'">
		<div class="header">
			<h4>{{ header }}</h4>
			<font-awesome-icon v-if="expanded" icon="fa-minus" size="1x" />
			<font-awesome-icon v-else icon="fa-plus" size="1x" />
		</div>
		<div class="faq-content content">
			<div v-parse-links v-html="content" />
		</div>
	</div>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	expanded: { type: Boolean, default: true },
});
</script>

<style lang="scss" scoped>
.header,
.content {
	font-size: 15px;
	padding: 20px;
	width: 100%;
	border-bottom: 1px solid #f1f1f1;
}

.container {
	text-align: left;
	display: inline-block;
	vertical-align: top;
	width: 100%;
	overflow: hidden;

	.header {
		background: var(--primary-background-color);
		cursor: pointer;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.expand-icon {
			color: var(--dark-background-color);
			font-size: 1.2em;
		}

		h4 {
			margin-bottom: 0;
		}
	}

	.content {
		padding: 20px;
		border-top: none;
		background: var(--secondary-background-color);
		transition: all 300ms ease;

		ul,
		ol {
			padding: 0 0 0 20px;
		}

		:deep(:first-child) {
			margin-top: 0;
		}

		:deep(:last-child) {
			margin-bottom: 0;
		}
	}

	&.not-expanded .content {
		transform: scaleY(0);
		transform-origin: top;
		opacity: 0;
		height: 0;
		padding: 0 20px;
	}
}
</style>
